import { render, staticRenderFns } from "./ConfirmBtn.vue?vue&type=template&id=4aa079b0&scoped=true&"
import script from "./ConfirmBtn.vue?vue&type=script&lang=js&"
export * from "./ConfirmBtn.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmBtn.vue?vue&type=style&index=0&id=4aa079b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa079b0",
  null
  
)

export default component.exports